import { render, staticRenderFns } from "./CounselingQuestions.vue?vue&type=template&id=c22e7578&scoped=true&lang=pug&"
import script from "./CounselingQuestions.vue?vue&type=script&lang=ts&"
export * from "./CounselingQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./CounselingQuestions.vue?vue&type=style&index=0&id=c22e7578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22e7578",
  null
  
)

export default component.exports